<template>
  <div class="tiny-text" style="font-weight: initial">
    <div v-if="years !== 'TODAY'">
      <span>{{ $options.filters.date(getStartDate(), 'DD.MM.YYYY') }}</span>
      <br v-if="br">
      <span> -&nbsp;{{ $options.filters.date(getEndDate(), 'DD.MM.YYYY') }}</span>
    </div>
    <div v-else>
      <span>{{ $options.filters.date(new Date(), 'DD.MM.YYYY') }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'DocTimeFrame',
  data() {
    return {
      enumMap: {
        ONE_YEAR: 1,
        THREE_YEARS: 3,
        FIVE_YEARS: 5,
        TEN_YEARS: 10,
      },
    }
  },
  props: {
    years: {},
    br: {
      default: true,
    },
  },
  methods: {
    getStartDate() {
      if (this.years === 'YTD') {
        return new Date().setMonth(0, 1)
      } else {
        let today = new Date()
        today.setFullYear(today.getFullYear() - this.enumMap[this.years])
        return today
      }
    },
    getEndDate() {
      return new Date()
    },
  },

}
</script>



// WEBPACK FOOTER //
// DocTimeFrame.vue?4c03478a